export let reportPhishing = "I1Ry_";
export default {reportPhishing};